import React from "react";
import PropTypes from "prop-types";
import { Form, message } from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap, List } from "immutable";
import CaseService from "services/case-service";
import StageService from "services/stage-service";
import DocumentRequestModal from "./document-request-modal";
import "styles/form.css";
import { INPUT_TYPES } from "constants";
import ReferToSaleCoordinatorModal from "./refer_to_sales_coordinator_modal_content";
// const FormItem = Form.Item;

const FORM_FIELDS = (disableSubmit) => new OrderedMap({
    stage: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Select Stage",
        rules: [
            {
                required: true,
                message: "Field Required"
            }
        ],
    
        onChange:(val) => {if(val == null || val == "") disableSubmit()},
        options: []
    },
    refer_reason_category: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Refer Reason Category",
        rules: [
            // {
            //     required: true,
            //     message: "Please Select atleast 1 reason"
            // }
        ],
        options: []
    },
    refer_reason_subcategory: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Refer Reason",
        rules: [],
        options: []
    },
    refer_remarks: {
        type: INPUT_TYPES.TEXTAREA,
        placeholder: "Refer Remarks",
        size: "large",
        rules: [
            {
                required: true,
                message: "Refer remarks are required"
            }
        ],
        onChange: null
    }
});
class RejectModalContent extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        referReasonsList: [],
        remarks: "",
        reason: "",
        subCategories: null,
        stages: [],
        stage: null,
        selected_user: null,
        disableForm: true,
        documentRequestModel: false,
        reasonId: null,
        subCategoryId: null
    };

    componentDidMount() {
        CaseService.getCategoryWiseReasons(this.props.stageId, 2 /*REFER*/).then(({ data }) => {
            this.setState({
                referReasonsList: data
            }, () => this.forceUpdate());
        });
        StageService.getStages(
            this.props.stageId,
            "refer",
            this.props.caseId
        ).then(({ data }) => {
            this.setState({
                stages: new List(data),
                disableForm: false
            }, () => {
                if (this.state.stages.size === 1) {
                    this.setState({
                        stage: this.state.stages.first().id
                    });
                }
            });
        }).catch(() => {
            this.setState({
                disableForm: false
            }, () => {
                message.error("Internet Connectivity Issue");
            });
        });
    }

    onChangeRemarks = (remarks , refer_reasons) => {
         if([4,5,18].includes(this.state.stage) && refer_reasons.length){
            let reason = this.state.referReasonsList && this.state.referReasonsList.find(_ => _.id == refer_reasons[0].refer_reason_category)
            if(reason){
                this.props.onChange({
                    userId: this.state.selected_user,
                    stageId: this.state.stage,
                    remarks: remarks,
                    reason: reason.name,
                    reasonId: reason.id,
                    subCategoryId: null,
                    refer_reasons
                });
            }
        }else{
            this.props.onChange({
                reason: this.state.reason,
                userId: this.state.selected_user,
                stageId: this.state.stage,
                remarks: remarks.target.value,
                reasonId: this.state.reasonId,
                subCategoryId: this.state.subCategoryId
            });
        }
    };

    disableSubmit = () => {
        this.props.onChange(null);
    }

    updateReferToSalesCoordinatorStage = (refer_reasons) => {
        if(refer_reasons.length){
            this.onChangeRemarks(refer_reasons[0].refer_remarks, refer_reasons)
        }
    }

    onSelectReason = val => {
        this.setState({
            subCategoryId: val
        });
    }

    onSelectReasonCategory = val => {
        let reasonCategory = this.state.referReasonsList && this.state.referReasonsList.find(_ => _.id == val);
        if (reasonCategory) {
            this.setState({
                reason: reasonCategory.name,
                reasonId: reasonCategory.id,
                subCategories: !reasonCategory.sub_categories.length ? null : reasonCategory.sub_categories,
                documentRequestModel: reasonCategory.category_type === 1 /* REQUEST_DOC */ ? true : false
            });
        }
    }

    onStageSelect = stageId => {
        this.setState({
            stage: Number(stageId)
        });
    };

    documentRequestModalCancel = () => {
        this.setState({
            documentRequestModel: false
        });
    };

    requestDocumentsHandler=() => {
        this.setState(
            {
                documentRequestModel: false
            }
        );
    };

    enhanceFormFields = () => {
        return FORM_FIELDS(this.disableSubmit)
            .setIn(["stage", "options"], this.state.stages && this.state.stages.map((_) => ({
                label: _.stage_name,
                value: _.id
            })))
            .setIn(["stage", "defaultValue"], this.state.stage ? this.state.stage : null)
            .setIn(["stage", "onChange"], this.onStageSelect)
            .setIn(["refer_reason_category", "options"], this.state.referReasonsList.map((_) => ({
                label: _.name,
                value: _.id
            })))
            .setIn(["refer_reason_category", "onSelect"], this.onSelectReasonCategory)
            .setIn(["refer_reason_subcategory", "options"], this.state.subCategories && this.state.subCategories.map((_) => ({
                label: _.name,
                value: _.id
            })))
            .setIn(["refer_reason_subcategory", "onSelect"], this.onSelectReason)
            .setIn(["refer_remarks", "onChange"], this.onChangeRemarks);
    }

    render() {
        this.fields = this.enhanceFormFields();
        return (
            <React.Fragment>
                <DocumentRequestModal 
                    requestModal={this.state.documentRequestModel}
                    requestDocumentsHandler={this.requestDocumentsHandler}
                    closeRequestModal={this.documentRequestModalCancel}
                    caseId={this.props.caseId}
                    companyId={this.props.companyId}
                />
                <Form hideRequiredMark={false} className={cx("form", "br-3")}>
                    <div className={"form-row"} style={{ display: "block" }}>
                        {this.fields
                            .filter((_ , k) => !(k == "stage" && (this.props.removeStageSelection || false)))
                            .filter((_, k) =>
                                (!this.state.referReasonsList || !this.state.referReasonsList.length) ?
                                    k !== "refer_reason_category" :
                                    _ !== null
                            )
                            .filter((_, k) => [4,5,18].includes(this.state.stage) ? !['refer_reason_subcategory' , 'refer_remarks' , 'refer_reason_category'].includes(k) : true)
                            .filter((_, k) => !this.state.subCategories ? k !== "refer_reason_subcategory" : _ !== null)
                            .map((field, fieldName) => {
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getErrorOnField(fieldName)
                                )();
                            }).toList()}
                    </div>
                </Form>
                {[4,5,18].includes(this.state.stage) && <ReferToSaleCoordinatorModal
                    stageId = {this.props.stageId}
                    referReasonsList={this.state.referReasonsList} 
                    updateReferToSalesCoordinatorStage={this.updateReferToSalesCoordinatorStage}
                    disableSubmit={this.disableSubmit}
                    showDocumentRequestModal ={() => this.setState({
                        documentRequestModel : true
                    })}
                 />}
            </React.Fragment>
        );
    }
}

RejectModalContent.propTypes = {
    onChange: PropTypes.func,
    form: PropTypes.object,
    rejectReason: PropTypes.object,
    stageId: PropTypes.number,
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    removeStageSelection: PropTypes.bool
};

export default Form.create({})(RejectModalContent);